import Dinero from "dinero.js";
import store from "state/store";
import {DOLLAR_SIGN, GAN_SIGN, getGroupCurrencySymbol} from "state/slices/group-slice";
import { SPORTZINO_SYMBOLS } from "utils/constants";

export const formatAsCurrency = (amount: number, useDollars?: boolean) => {
  const state = store.getState();
  let currencySymbol;
  currencySymbol = getGroupCurrencySymbol(state);

  if (useDollars) {
    currencySymbol = DOLLAR_SIGN;
  }

  if (currencySymbol === GAN_SIGN) {
    currencySymbol = ""
  }

  const dinero: string = Dinero({ amount: Math.floor(amount * 100) })
    .toFormat()

  return SPORTZINO_SYMBOLS.includes(currencySymbol) ?
    dinero.replace("$", currencySymbol + " ") :
    dinero.replace("$", currencySymbol)
};

export const formattedCurrencyToNumber = (value: string): number => {
  return parseFloat(value.replace(/[^0-9.]+/g, ""));
};

export const formatAsDollars = (amount: number) =>
  formatAsCurrency(amount, true);
